import * as React from 'react';
import { IFeature } from '../../types/project';
import { FeatureMobile } from './components/FeatureMobile';
import { Section } from '../Section';

interface IFeaturesMobileProps {
  features: IFeature[];
}

export const FeaturesMobile: React.FC<IFeaturesMobileProps> = ({ features }) => {
  return (
    <Section title="О проекте">
      {features.map((feature, index) => (
        <FeatureMobile key={index} {...feature} />
      ))}
    </Section>
  );
};
